export enum footerKeys {
    onlineLinks = 'Links',
    contact = 'Kontakt',
    imprint = 'Impressum',
    privacy = 'Datenschutzerklaerung',
    termsOfService = 'AGB'
}